import { render, staticRenderFns } from "./Appeals.vue?vue&type=template&id=318c6d10&"
import script from "./Appeals.vue?vue&type=script&lang=js&"
export * from "./Appeals.vue?vue&type=script&lang=js&"
import style0 from "./Appeals.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports